<template>
  <ssp-authenticator />
</template>
<script>
import { LOGIN, MODULE_NAME as AUTH_MODULE } from '../store/types'
import {
  INITIALIZE,
  MODULE_NAME as NOTIFICATION_MODULE
} from '../../toast/store/types'

export default {
  data() {
    return {
      username: '',
      password: '',
      showPassword: false,
      loginFailedAlert: false,
      loginFailedMessage: '',
      loginLoading: false,
      nameRules: {
        required: value => value.trim().length > 0 || 'Must not be empty.'
      },
      passwordRules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  computed: {
    valid: {
      get() {
        return (
          this.username.trim().length > 0 && this.password.trim().length > 0
        )
      },
      set() {}
    }
  },
  methods: {
    signIn() {
      if (!this.username || this.username.trim().length === 0) {
        this.showLoginFailed('Username must not be empty.')
      } else if (!this.password || this.password.trim().length === 0) {
        this.showLoginFailed('Password must not be empty.')
      } else {
        this.loginLoading = true
        this.$store
          .dispatch(`${AUTH_MODULE}/${LOGIN}`, {
            username: this.username,
            password: this.password
          })
          .then(() => {
            this.loginLoading = false
            const nextRoute = this.$route.query.nextRoute
              ? this.$route.query.nextRoute
              : '/'
            this.$store
              .dispatch(`${NOTIFICATION_MODULE}/${INITIALIZE}`)
              .then(() => {
                this.$router.push(nextRoute)
              })
            this.$router.push(nextRoute)
          })
          .catch(() => {
            this.loginLoading = false
            this.showLoginFailed('Username or password is not correct.')
          })
      }
    },
    showLoginFailed(err) {
      this.loginFailedMessage =
        err.message !== undefined ? err.message : err.toString()
      this.loginFailedAlert = true
    }
  }
}
</script>
